export const aboutIs = {
  hero: {
    title: 'Sagan okkar',
    subtitle: 'Frá sólríkum götum Napólí til hjarta Reykjavíkur',
  },
  history: {
    title: 'Sagan okkar',
    content: [
      'Rossopomodoro er sneiðmynd af lífinu í Napoli á suður Ítalíu, útlit staðarins, matseðillinn og klæðaburður starfsfólksins eru til marks um þá hugmyndafræði. Staðsett á Laugavegi, aðal verslunargötu Reykjavíkur, höfum við orðið vinsæll veitingastaður fyrir heimamenn og ferðamenn sem leita að bestu ítölsku matargerðinni í Reykjavík.',
      'Viðarofninn okkar var byggður af þriðju kynslóð napólskra handverksmanna og sendur alla leið til Íslands. Eldfjallasteininn sem notaður er í byggingu hans skapar fullkomið eldunaumhverfi fyrir pizzurnar okkar, nær 485°C (905°F) hitastigi og eldar fullkomna napólska pizzu á aðeins 90 sekúndum. Þessi ekta nálgun er ástæðan fyrir því að margir telja okkur besta pizzastaðinn í Reykjavík.',
    ],
    since: 'Síðan 2006',
  },
  location: {
    title: 'Komdu í heimsókn',
    subtitle: 'Staðsett í hjarta Reykjavíkur á lifandi Laugaveginum',
    content: [
      'Ítalski veitingastaðurinn okkar er fullkomlega staðsettur á Laugavegi 40a, aðalgöngugötu Reykjavíkur, sem gerir hann auðveldlega aðgengilegan hvort sem þú ert að kanna miðbæ Reykjavíkur eða leitar að bestu pizzunni í miðbænum.',
      'Við erum aðeins í stuttri göngufjarlægð frá helstu kennileitum þar á meðal Hallgrímskirkju, Hörpu tónlistarhúsi og gamla höfninni. Götubílastæði og almenningssamgöngur eru aðgengilegar, sem gerir okkur auðfundna í miðbæ Reykjavíkur.',
    ],
    address: 'Laugavegi 40a, 101 Reykjavík',
    directions: 'Fá leiðbeiningar',
    poi: {
      hallgrimskirkja: {
        name: 'Hallgrímskirkja',
        distance: '350 m',
        walkTime: '5 mín ganga',
      },
      harpa: {
        name: 'Harpa',
        distance: '850 m',
        walkTime: '13 mín ganga',
      },
    },
  },
  values: {
    title: 'Gildin okkar',
    subtitle: 'Meginreglurnar sem við höfum alltaf að leiðarljósi',
    items: [
      {
        title: 'Áreiðanleiki',
        description:
          'Við gerum engar málamiðlanir þegar kemur að ekta bragði. Frá hráefnum til aðferða – allt sem við gerum er í anda napólskra hefða.',
      },
      {
        title: 'Gæði',
        description:
          'Við notum aðeins bestu hráefnin, mörg flutt beint frá Ítalíu, og sameinum þau bestu staðbundnu afurðum sem Ísland hefur upp á að bjóða.',
      },
      {
        title: 'Gestrisni',
        description:
          'Við bjóðum hvern gest velkominn eins og fjölskyldu. Hlý og hjartnæm þjónusta okkar færir þér hina sönnu ítölsku gestrisni.',
      },
    ],
  },
};
